module.exports = __webpack_public_path__ + "img/bf-tree.21c34365.png";